import React from 'react';
import EditButton from 'ui/EditButton';
import DetailsButton from 'ui/DetailsButton';
import { MTable } from 'ui/mtable/MTable';

import formatters from '../../../../formatters';
import { ConnectorStatusChip } from './Status';
import {
    isAzureConnector,
    ActionTypes,
    isValidConnector,
    isAvaliableToSync,
} from '../Consts';

const getColumns = (editable, onAction, withVersionColumn) =>
    [
        {
            field: 'name',
            title: 'Name',
            render: val => <strong>{val.name}</strong>,
            cellStyle: {
                width: '50%',
            },
        },
        {
            field: 'accounts_count',
            title: 'Accounts',
            cellStyle: {
                width: '120px',
            },
        },
        {
            field: 'groups_count',
            title: 'Groups',
            cellStyle: {
                width: '120px',
            },
        },
        {
            field: 'version',
            title: 'Version',
            cellStyle: {
                width: '120px',
            },
        },
        {
            field: 'last_sync_date',
            title: 'Last Sync',
            render: val => formatters.date(val.last_sync_date),
            cellStyle: {
                minWidth: '200px',
            },
        },
        {
            field: 'status',
            title: 'Status',
            render: row => <ConnectorStatusChip connector={row} />,
            exportValue: val => {
                return val === 'waiting'
                    ? 'Waiting for connection'
                    : 'Connected';
            },
            cellStyle: {
                width: '240px',
                filterType: 'select',
            },
        },
        {
            field: 'action',
            title: '',
            notFilter: true,
            export: false,
            render: ({ identifier }) => {
                if (editable) {
                    return (
                        <EditButton
                            onClick={() =>
                                onAction(ActionTypes.EDIT, { identifier })
                            }
                        />
                    );
                } else {
                    return (
                        <DetailsButton
                            onClick={() =>
                                onAction(ActionTypes.DETAILS, {
                                    identifier,
                                })
                            }
                        />
                    );
                }
            },
            cellStyle: {
                width: '160px',
            },
        },
    ].filter(({ id }) => withVersionColumn || id !== 'version');

export default function ConnectorTables({
    connectors,
    loading,
    editable,
    onAction,
}) {
    if (connectors.length) {
        const connector = connectors[0];
        const canSynchronize = connector =>
            isAzureConnector(connector) && isValidConnector(connector);
        const getActions = connectors => {
            const { identifier } = connector;
            const onClick = () => onAction(ActionTypes.REMOVE, { identifier });
            const menuItems = [
                {
                    key: 'delete',
                    name: 'Delete connector',
                    onClick,
                },
            ];
            if (connectors.every(canSynchronize)) {
                menuItems.push({
                    key: 'synchronize',
                    name: 'Synchronize Now',
                    disabled: !connectors.every(isAvaliableToSync),
                    onClick: () =>
                        onAction(ActionTypes.SYNCHRONIZE, { identifier }),
                });
            }
            return menuItems;
        };
        const withVersionColumn = !isAzureConnector(connector);
        const actions = getActions(connectors);

        return (
            <MTable
                stateKey="Connectors"
                columns={getColumns(editable, onAction, withVersionColumn)}
                data={connectors}
                loading={loading}
                searchPlaceholder="Find connectors"
                actionMenuItems={actions}
                options={{
                    selection: true,
                }}
            />
        );
    }
    return null;
}
